import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { homepageBreadcrumbItems } from 'data/commonData';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { Placeholder } from 'react-bootstrap';
import { Col, Row } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { GET_JOBS_QUERY } from 'services/api/job';
import ArchiveProjectsTopSection from './../../../components/modules/project-management/ArchiveProjectsTopSection';
import { GET_JOBSTAGE_QUERY, JobStage } from 'services/api/jobStage';
import ArchiveCardViewItem from 'components/modules/project-management/card-view/ArchiveCardView';
import { useState } from 'react';
import { usePermissions } from 'hooks/usePermissions';
import { PERMISSIONS } from 'constants/permissions';

const ArchiveView = () => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const { data: jobs, isLoading } = useQuery('getJobs', GET_JOBS_QUERY, {
    staleTime: 3 * 60 * 60 * 1000
  });

  const { data: JobStages } = useQuery('getJobStages', GET_JOBSTAGE_QUERY, {
    staleTime: 3 * 60 * 60 * 1000
  });

  const archivedJobs = jobs?.data?.filter(
    job =>
      job?.jobStage?.name.toLowerCase() === 'closed' ||
      job?.jobStage?.name?.toLowerCase() === 'cancelled'
  );

  const filteredJobs = archivedJobs?.filter(job => {
    const searchString = searchTerm?.toLowerCase();
    return (
      job.title?.toLowerCase().includes(searchString) ||
      job.well?.toLowerCase().includes(searchString) ||
      job.jobNumber?.toLowerCase().includes(searchString) ||
      job.customer?.organizationName?.toLowerCase().includes(searchString) ||
      job.location?.location?.toLowerCase().includes(searchString)
    );
  });

  const handleSearch = (term: string) => {
    setSearchTerm(term);
  };

  const [canMoveToActiveJob, canEditArchiveJob] = usePermissions([
    PERMISSIONS.DASHBOARD.ARCHIVE_JOBS.MOVE_TO_ACTIVE_JOB,
    PERMISSIONS.DASHBOARD.ARCHIVE_JOBS.UPDATE_ARCHIVE_JOB
  ]);
  console.log(canMoveToActiveJob, canEditArchiveJob, 'canMoveToActiveJob');
  return (
    <div>
      <PageBreadcrumb items={homepageBreadcrumbItems} />
      <AdvanceTableProvider>
        <div className="d-flex flex-wrap mb-4 gap-3 gap-sm-6 align-items-center">
          <h2 className="mb-0">
            <span className="me-3">Archived Jobs</span>{' '}
            <span className="fw-normal text-700">({archivedJobs?.length})</span>
          </h2>
        </div>
        <div className="d-flex justify-content-start">
          <ArchiveProjectsTopSection
            activeView="card"
            onSearch={handleSearch}
          />
        </div>
        {isLoading ? (
          <div className="g-3 mt-8 mb-8">
            <Placeholder as="p" animation="glow">
              <Placeholder xs={12} />
            </Placeholder>
            <Placeholder as="p" animation="glow">
              <Placeholder xs={12} />
            </Placeholder>
          </div>
        ) : filteredJobs?.length === 0 ? (
          <div className="text-center py-5">
            <h3 className="text-700">No results found</h3>
            <p className="text-600">
              Try adjusting your search to find what you're looking for.
            </p>
          </div>
        ) : (
          <Row className="g-3 mb-9">
            {filteredJobs?.map(project => (
              <Col xs={12} sm={6} xl={4} xxl={3} key={project._id}>
                <ArchiveCardViewItem
                  project={project}
                  JobStages={JobStages?.data as JobStage[]}
                  getJobStage={true}
                  canMoveToActiveJob={canMoveToActiveJob}
                  canUpdateArchiveJob={canEditArchiveJob}
                />
              </Col>
            ))}
          </Row>
        )}
      </AdvanceTableProvider>
    </div>
  );
};

export default ArchiveView;
